// The Main Subject/Stream to be listened on.
import {Subject} from "rxjs";

export const eventsSubject = new Subject();

// This function is used to publish data to the Subject via next().
export const publish = (topic, data) => {
    eventsSubject.next({topic, data})
};